import * as React from "react";
import { TextBox } from "../../forms/informedv2/TextBox";
import { TimePicker } from "../../forms/informedv2/TimePicker";
import { Required } from "../../forms/validation/Required";
import { SubjectAlarms } from "./SubjectAlarms";

interface SubjectEdiaryFormBodyProps {
    enabled: boolean;
}

export const SubjectEdiaryFormBody = ({ enabled }: SubjectEdiaryFormBodyProps) => {
    if (!enabled) return null;

    return (
        <>
            <div className="row">
                <div className="form-group col-sm-4 col-xs-12">
                    <label htmlFor="Pin">PIN</label>
                    <TextBox id="Pin" field="Pin" required={true} placeholder="####" type="password" validate={Required} autoComplete="new-password" />
                </div>

                <div className="form-group col-sm-4 col-xs-12">
                    <label htmlFor="PinConfirmation">PIN Confirmation</label>
                    <TextBox id="PinConfirmation" field="PinConfirmation" required={true} placeholder="####" type="password" validate={Required} autoComplete="new-password" />
                </div>
                <div className="form-group col-sm-4 col-xs-12">
                    <TimePicker
                        id="BedTime"
                        field="BedTime"
                        label="Bed Time"
                        placeholderText="HH:mm (24 hour format)"
                        required={false}
                        dateFormat="HH:mm"
                    />
                </div>
            </div>

            <SubjectAlarms />

        </>
    );
}
